var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.145 18.887c.28 0 .48-.059.6-.176.121-.117.182-.32.182-.606v-5.883l-.02-.055a.875.875 0 0 1-.03-.233c0-.085.01-.162.029-.231l.02-.059V5.781c0-.28-.06-.48-.18-.6S7.426 5 7.146 5H5.23c-.28 0-.48.06-.6.18-.12.121-.181.321-.181.601v12.324c0 .287.06.489.18.606.121.117.321.176.601.176h1.914zm11.465-.352a.86.86 0 0 0 .591-.244c.179-.163.269-.426.269-.791V6.387c0-.365-.09-.629-.269-.791a.86.86 0 0 0-.59-.244c-.112 0-.23.026-.357.078-.127.052-.24.104-.337.156l-9.62 5.654a.984.984 0 0 0-.307.279.552.552 0 0 0-.05.086l-.014.039v.578l.018.046.05.09a.92.92 0 0 0 .304.279l9.619 5.654c.09.059.202.114.332.166.13.052.25.078.361.078z",
    fill: "#8F9BB3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.5ac27305.svg";
export { ForwardRef as ReactComponent };